module.exports = __webpack_public_path__ + "img/94.c676dd72.jpg";